import type { Header } from "@features/headers"
import type { Agency } from "@features/user"
import Card from "components/Card"
import EmptyState from "components/EmptyState"
import type { FC } from "react"
import { Trans } from "react-i18next"
import type { Offer } from "../../offersList/offersListTypes"
import NewsletterHeaderPicker from "./NewsletterHeaderPicker"
import NewsletterPreview from "./NewsletterPreview"
import NewsletterSelectedOffers from "./NewsletterSelectedOffers"

interface NewsletterPreviewSectionProps {
  selected: Offer[]
  header: Header | null
  headerUrl: string | null
  draggingIndex: number | null
  agency: Agency | undefined
  onOpenPicker: () => void
  onRemoveHeader: () => void
  onDragStart: (index: number) => (e: React.DragEvent<HTMLLIElement>) => void
  onDragOver: (e: React.DragEvent<HTMLLIElement>) => void
  onDrop: (toIndex: number) => (e: React.DragEvent<HTMLLIElement>) => void
  onDragEnd: () => void
  onEdit: (offerId: string) => void
  onRemove: (offer: Offer) => void
  onMoveUp: (index: number) => void
  onMoveDown: (index: number) => void
  onClear: () => void
}

const NewsletterPreviewSection: FC<NewsletterPreviewSectionProps> = ({
  selected,
  header,
  headerUrl,
  draggingIndex,
  agency,
  onOpenPicker,
  onRemoveHeader,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  onEdit,
  onRemove,
  onMoveUp,
  onMoveDown,
  onClear,
}) => {
  return (
    <Card title={<Trans i18nKey="newsletter.preview.title" />}>
      {selected.length === 0 ? (
        <EmptyState padding="md">
          <Trans i18nKey="newsletter.empty.addOffer" />
        </EmptyState>
      ) : (
        <div className="p-3">
          <NewsletterHeaderPicker
            header={header}
            headerUrl={headerUrl}
            onOpenPicker={onOpenPicker}
            onRemoveHeader={onRemoveHeader}
          />
          <NewsletterSelectedOffers
            selected={selected}
            draggingIndex={draggingIndex}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDrop={onDrop}
            onDragEnd={onDragEnd}
            onEdit={onEdit}
            onRemove={onRemove}
            onMoveUp={onMoveUp}
            onMoveDown={onMoveDown}
            onClear={onClear}
          />
          <NewsletterPreview offers={selected} agency={agency} />
        </div>
      )}
    </Card>
  )
}

export default NewsletterPreviewSection
